<template>
  <yd-table
    :data="tableData"
    :loading="loading"
    element-loading-text="正在加载中～"
    :pagination="pageState"
    @onChange="onTableChange"
    max-height="400"
  >
    <el-table-column align="center" prop="orderNo" label="订单号" width="250">
      <template slot-scope="{ row }">
        <el-tooltip placement="right" effect="dark" trigger="hover" tabindex="1" hide-after="800">
          <template v-slot:content>
            <span style="cursor: pointer" @click="copyOrderNo(row.orderNo)">复制</span>
          </template>
          <span class="color-mainColor pointer" @click="handleDetail(row)">{{ row.orderNo }}</span>
        </el-tooltip>
      </template>
    </el-table-column>
    <el-table-column align="center" prop="orderDepart" label="预计出行时间" width="180" />
    <el-table-column align="center" prop="typeName" label="类型" />
    <el-table-column align="center" prop="statusName" label="订单状态" />
    <el-table-column
      align="center"
      prop="startAddress"
      label="出发地"
      width="200"
      show-overflow-tooltip
    />
    <el-table-column
      align="center"
      prop="endAddress"
      label="目的地"
      width="180"
      show-overflow-tooltip
    />
    <el-table-column align="center" prop="createTime" label="接单时间" width="180" />
    <el-table-column
      align="center"
      prop="supervisor"
      label="出发接人"
      width="200"
      show-overflow-tooltip
    >
      <template slot-scope="{ row }">
        <div class="flex flex-col" @click="situationDetail(row.one, 'one')">
          <span class="situation pointer">{{ row.one ? row.one.operationTime : '' }}</span>
          <span class="situation pointer">{{ row.one ? row.one.location : '' }}</span>
        </div>
      </template>
    </el-table-column>
    <el-table-column
      align="center"
      prop="supervisor"
      label="到达上车点"
      width="200"
      show-overflow-tooltip
    >
      <template slot-scope="{ row }">
        <div class="flex flex-col" @click="situationDetail(row.two, 'two')">
          <span class="situation pointer">{{ row.two ? row.two.operationTime : '' }}</span>
          <span class="situation pointer">{{ row.two ? row.two.location : '' }}</span>
        </div>
      </template>
    </el-table-column>
    <el-table-column
      align="center"
      prop="supervisor"
      label="乘客上车"
      width="200"
      show-overflow-tooltip
    >
      <template slot-scope="{ row }">
        <div class="flex flex-col" @click="situationDetail(row.three, 'three')">
          <span class="situation pointer">{{ row.three ? row.three.operationTime : '' }}</span>
          <span class="situation pointer">{{ row.three ? row.three.location : '' }}</span>
        </div>
      </template>
    </el-table-column>
    <el-table-column
      align="center"
      prop="supervisor"
      label="到达目的地"
      width="200"
      show-overflow-tooltip
    >
      <template slot-scope="{ row }">
        <div class="flex flex-col" @click="situationDetail(row.four, 'four')">
          <span class="situation pointer">{{ row.four ? row.four.operationTime : '' }}</span>
          <span class="situation pointer">{{ row.four ? row.four.location : '' }}</span>
        </div>
      </template>
    </el-table-column>
  </yd-table>
</template>

<script >
import { inject } from '@vue/composition-api';
import { Message } from 'element-ui';
import { copyText } from '@/util/util';
const __sfc_main = {};
__sfc_main.setup = (__props, __ctx) => {
  const emit = __ctx.emit;
  const tableData = inject('tableData');
  const handleSizeChange = inject('handleSizeChange');
  const handleCurrentChange = inject('handleCurrentChange');
  const pageState = inject('pageState', {});
  const loading = inject('loading');
  const onTableChange = ({
    current,
    pageSize,
    type
  }) => {
    if (type === 'currentChange' || type === 'fresh') {
      handleCurrentChange(current);
    }
    if (type === 'sizeChange') {
      handleSizeChange(pageSize);
    }
  };
  const handleDetail = row => {
    emit('orderDetail', row);
  };
  const situationDetail = (obj, type) => {
    obj.type = type;
    emit('situationDetail', obj);
  };
  // 复制订单号
  const copyOrderNo = async orderNo => {
    await copyText(orderNo);
    Message.success('复制成功');
  };
  return {
    tableData,
    pageState,
    loading,
    onTableChange,
    handleDetail,
    situationDetail,
    copyOrderNo
  };
};
export default __sfc_main;
</script>

<style lang="scss" scoped>
  .situation {
    text-decoration: underline;
  }
</style>
